import { defineStore } from 'pinia'
import { journalsApi } from '../api/journalsApi'
import { logJournalHttpError } from '../composables/useErrorHandler'
import { normalizeFilterChoice } from '../utils/normalizeFilterChoice'
import type { IFilterChoiceItem } from '@/modules/universalStats/types/IFilterChoiceItem'

export const useJournalFilterStore = defineStore('journalFilter', {
  state: () => ({
    journalId: null as number | null,
    filterChoices: {} as Record<string, IFilterChoiceItem[]>,
    searchChoices: {} as Record<string, IFilterChoiceItem[]>,
    filterCursors: {} as Record<string, string | null>,
    filterLoading: {} as Record<string, boolean>,
    filterStrategies: {} as Record<string, string>,
  }),

  actions: {
    setJournalId(id: number | null) {
      this.journalId = id
    },

    async fetchFilterChoices(
      module: 'adverse' | 'ticket' | 'document' | 'journal',
      fieldKey: string,
      search = '',
      _cursor?: string,
    ): Promise<void> {
      if (module !== 'journal' || this.journalId == null) {
        return
      }

      this.filterLoading[fieldKey] = true
      try {
        const raw = await journalsApi.getAttributeChoices(
          this.journalId,
          fieldKey,
          true,
          search || undefined,
        )

        const full = raw.map(normalizeFilterChoice)

        this.filterChoices[fieldKey] = full
        this.searchChoices[fieldKey] = full
        this.filterCursors[fieldKey] = null
        this.filterStrategies[fieldKey] = 'independent'
      } catch (e) {
        logJournalHttpError(e, {
          function: 'fetchFilterChoices',
          store: 'journalFilterStore',
          payload: { fieldKey, search, journalId: this.journalId },
        })
        throw e
      } finally {
        this.filterLoading[fieldKey] = false
      }
    },
  },
})
